import { writable } from 'svelte/store';
import { TIMEOUT_SCROLL_DIRECTION_THROTTLE } from '../constants';
function createScrollStateStore() {
    const { subscribe, update } = writable({
        direction: null,
        isPastWaypoint: false,
        offsetY: 0,
    });
    let lastScrollY = 0;
    let throttleTimeout = null;
    let lastDirection = null;
    let ignoreNextScroll = false; // used to ignore scroll event that occurs after the body is unlocked on BodyScrollLocker
    function setIgnoreNextScroll() {
        ignoreNextScroll = true;
    }
    // Set by scroll event listener
    function setScrollProps() {
        if (throttleTimeout)
            return;
        // Ignore scroll direction updates when body is being locked
        if (ignoreNextScroll) {
            ignoreNextScroll = false; // reset
            return;
        }
        throttleTimeout = window.setTimeout(() => {
            const currentScrollY = window.scrollY;
            const direction = currentScrollY > lastScrollY ? 'down' : 'up';
            setScrollOffsetY(currentScrollY);
            setScrollDirection(direction);
            throttleTimeout = null;
        }, TIMEOUT_SCROLL_DIRECTION_THROTTLE);
    }
    function setScrollOffsetY(newScrollY) {
        if (newScrollY === lastScrollY)
            return;
        update((state) => {
            state.offsetY = newScrollY;
            return state;
        });
        lastScrollY = newScrollY;
    }
    function setScrollDirection(newDirection) {
        if (newDirection === lastDirection)
            return;
        update((state) => {
            state.direction = newDirection;
            return state;
        });
        lastDirection = newDirection;
    }
    // Set by Waypoint component
    function setWaypointPassed(isPastWaypoint) {
        update((state) => {
            state.isPastWaypoint = isPastWaypoint;
            return state;
        });
    }
    if (typeof window !== 'undefined') {
        window.addEventListener('scroll', setScrollProps, { passive: true });
    }
    return {
        subscribe,
        setWaypointPassed,
        setIgnoreNextScroll,
    };
}
export const scrollState = createScrollStateStore();
